import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

interface RewardRedemptionInfoProps {
  readonly totalRedeemAmount?: number;
  readonly redeemReward?: string;
}

export default function RewardRedemptionInfo({ redeemReward, totalRedeemAmount }: RewardRedemptionInfoProps) {
  return (
    <div className="flex justify-between">
      <div>
        <Text variant="body-1">Redeemed Reward</Text>
        <Text variant="caption-1">{redeemReward}</Text>
      </div>
      <Text variant="body-1" className="w-36 text-right">
        ({numberUtils.formatCurrency(Math.abs(totalRedeemAmount ?? 0), 'Rp.')})
      </Text>
    </div>
  );
}
